import { gql } from '@apollo/client'

import {
    BAMBOOHR,
    BOOKING,
    DEPARTMENT,
    EMPLOYEE,
    OFFICE,
    PERSONIO,
    POSITION,
    RESERVABLE,
    RULES,
    SPACE,
    SUBSCRIBED_BILLING,
    SUBSCRIPTION_FOR_COMPANY,
} from './dataQuery'

// Department
export const SUBSCRIPTION_CREATE_DEPARTMENT = gql`
    subscription OnCreateDepartment($companyID: String!) {
        onCreateDepartment(companyID: $companyID) {
            ${DEPARTMENT}
            TeamLead {
                ${EMPLOYEE}
            }
            DepartmentRules {
                blockReservationOnNonOfficeDays
                enableMinDaysInOffice
                minDaysInOffice
                officeDays
                minDaysInOfficeTimeUnit
            }
            EmployeeToDepartment {
                items {
                    id
                    Employee {
                        ${EMPLOYEE}
                    }
                }
            }
        }
    }
`

export const SUBSCRIPTION_UPDATE_DEPARTMENT = gql`
    subscription OnUpdateDepartment($companyID: String!) {
        onUpdateDepartment(companyID: $companyID) {
            ${DEPARTMENT}
            TeamLead {
                ${EMPLOYEE}
            }
            DepartmentRules {
                blockReservationOnNonOfficeDays
                enableMinDaysInOffice
                minDaysInOffice
                officeDays
                minDaysInOfficeTimeUnit
            }
            EmployeeToDepartment {
               items {
                   id
                   Employee {
                       ${EMPLOYEE}
                   }
               }
            }
        }
    }
`

export const SUBSCRIPTION_DELETE_DEPARTMENT = gql`
    subscription OnDeleteDepartment($companyID: String!) {
        onDeleteDepartment(companyID: $companyID) {
            ${DEPARTMENT}
        }
    }
`

// Position
export const SUBSCRIPTION_CREATE_POSITION = gql`
    subscription OnCreatePosition($companyID: String!) {
        onCreatePosition(companyID: $companyID) {
            ${POSITION}
        }
    }
`

export const SUBSCRIPTION_UPDATE_POSITION = gql`
    subscription OnUpdatePosition($companyID: String!) {
        onUpdatePosition(companyID: $companyID) {
            ${POSITION}
        }
    }
`

export const SUBSCRIPTION_DELETE_POSITION = gql`
    subscription OnDeletePosition($companyID: String!) {
        onDeletePosition(companyID: $companyID) {
            ${POSITION}
        }
    }
`

// Waiting List
export const SUBSCRIPTION_CREATE_WAITINGLISTITEM = gql`
    subscription OnCreateWaitingListItem($companyID: String!) {
        onCreateWaitingListItem(companyID: $companyID) {
            date
            spaceID
            employeeID
        }
    }
`

// Reservable
export const SUBSCRIPTION_CREATE_RESERVABLE = gql`
    subscription OnCreateReservable($companyID: String!) {
        onCreateReservable(companyID: $companyID) {
            ${RESERVABLE}
            Employee {
                ${EMPLOYEE}
                Position {
                    ${POSITION}
                }
            }
            Department {
                ${DEPARTMENT}
            }
        }
    }
`

export const SUBSCRIPTION_UPDATE_RESERVABLE = gql`
    subscription OnUpdateReservable($companyID: String!) {
        onUpdateReservable(companyID: $companyID) {
            ${RESERVABLE}
            Employee {
                ${EMPLOYEE}
                Position {
                    ${POSITION}
                }
            }
            Department {
                ${DEPARTMENT}
            }
        }
    }
`

export const SUBSCRIPTION_DELETE_RESERVABLE = gql`
    subscription OnDeleteReservable($companyID: String!) {
        onDeleteReservable(companyID: $companyID) {
            ${RESERVABLE}
            Employee {
                ${EMPLOYEE}
                Position {
                    ${POSITION}
                }
            }
            Department {
                ${DEPARTMENT}
            }
        }
    }
`

// Space
export const SUBSCRIPTION_CREATE_SPACE = gql`
    subscription OnCreateSpace($companyID: String!) {
        onCreateSpace(companyID: $companyID) {
            ${SPACE}
            Reservables {
                items {
                    ${RESERVABLE}
                    Employee {
                        ${EMPLOYEE}
                        Position {
                            ${POSITION}
                        }
                    }
                    Department {
                        ${DEPARTMENT}
                    }
                }
            }
        }
    }
`

export const SUBSCRIPTION_UPDATE_SPACE = gql`
    subscription OnUpdateSpace($companyID: String!) {
        onUpdateSpace(companyID: $companyID) {
            ${SPACE}
            Reservables {
                items {
                    ${RESERVABLE}
                    Employee {
                        ${EMPLOYEE}
                        Position {
                            ${POSITION}
                        }
                    }
                    Department {
                        ${DEPARTMENT}
                    }
                }
            }
        }
    }
`

export const SUBSCRIPTION_DELETE_SPACE = gql`
    subscription OnDeleteSpace($companyID: String!) {
        onDeleteSpace(companyID: $companyID) {
            ${SPACE}
            Reservables {
                items {
                    ${RESERVABLE}
                    Employee {
                        ${EMPLOYEE}
                        Position {
                            ${POSITION}
                        }
                    }
                    Department {
                        ${DEPARTMENT}
                    }
                }
            }
        }
    }
`

export const SUBSCRIPTION_CREATE_EMPLOYEE = gql`
    subscription OnCreateEmployee($companyID: String!) {
        onCreateEmployee(companyID: $companyID) {
            ${EMPLOYEE}
            Position {
                ${POSITION}
            }
            Office {
                ${OFFICE}
            }
            Bookings {
                items {
                    ${BOOKING}
                    reservable {
                        ${RESERVABLE}
                    }
                }
            }
        }
    }
`
export const SUBSCRIPTION_UPDATE_EMPLOYEE = gql`
    subscription OnUpdateEmployee($companyID: String!) {
        onUpdateEmployee(companyID: $companyID) {
            ${EMPLOYEE}
            Position {
                ${POSITION}
            }
            Office {
                ${OFFICE}
            }
            Bookings {
                items {
                    ${BOOKING}
                    reservable {
                        ${RESERVABLE}
                    }
                }
            }
        }
    }
`

export const SUBSCRIPTION_DELETE_EMPLOYEE = gql`
    subscription OnDeleteEmployee($companyID: String!) {
        onDeleteEmployee(companyID: $companyID) {
            ${EMPLOYEE}
            Position {
                ${POSITION}
            }
            Office {
                ${OFFICE}
            }
            Bookings {
                items {
                    ${BOOKING}
                    reservable {
                        ${RESERVABLE}
                    }
                }
            }
        }
    }
`

export const SUBSCRIPTION_CREATE_BOOKING = gql`
    subscription OnCreateBooking($companyID: String!) {
        onCreateBooking(companyID: $companyID) {
            id
            startTime
            endTime
            isTeamEvent
            employeeID
            companyID
            owner
            isFullDay
            BookingRequest {
                repeatType
            }
            reservable {
                id
                type
                Space {
                    id
                    name
                }
            }
        }
    }
`

export const SUBSCRIPTION_DELETE_BOOKING = gql`
    subscription OnDeleteBooking($companyID: String!) {
        onDeleteBooking(companyID: $companyID) {
            id
            employeeID
            startTime
        }
    }
`

export const SUBSCRIPTION_BAMBOOHR = gql`
    subscription OnUpdatedBambooHRIntegration($companyId: String!) {
        onUpdatedBambooHRIntegration(companyId: $companyId) {
            ${BAMBOOHR}
        }
    }
`

export const SUBSCRIPTION_PERSONIO = gql`
    subscription OnLogPersonioIntegrationExecutionResult($companyID: String!) {
        onLogPersonioIntegrationExecutionResult(companyID: $companyID) {
            ${PERSONIO}
        }
    }
`

// Billing
export const SUBSCRIPTION_BILLING_UPDATE = gql`
    subscription OnUpdateBillingSubscription($companyId: String!) {
        onUpdateBillingSubscription(companyId: $companyId) {
            ${SUBSCRIBED_BILLING}
            ${SUBSCRIPTION_FOR_COMPANY}
        }
    }
`

export const SUBSCRIPTION_COMPANY_TARIFF_UPDATE = gql`
    subscription OnCompanyTariffUpdate($companyId: String!) {
        onCompanyTariffUpdate(companyId: $companyId) {
            companyId
            tariff
        }
    }
`

export const SUBSCRIPTION_COMPANY_RULES_UPDATE = gql`
    subscription OnUpdateRules($companyId: String!) {
        onUpdateRules(id: $companyId) {
            ${RULES}
        }
    }
`

export const SUBSCRIPTION_UPDATE_USER = gql`
    subscription OnUpdateUser($companyId: String!, $id: String!) {
        onUpdateEmployeeById(companyID: $companyId, id: $id) {
            id
            firstname
            lastname
            cognitoUserId
            email
            photo
            role
            locale
            favouriteOfficeID
            departmentIDs
            Position {
                id
                name
            }
            Office {
                id
                name
            }
            notificationChannels
            shareAttendance
            demoAccountID
            favouriteColleagueIDs
            favouriteReservableID
        }
    }
`

export const SUBSCRIPTION_CREATE_ROOM_EVENT = gql`
    subscription OnCreateRoomEvent($companyID: String!, $reservableID: String!) {
        onCreateCalendarEventByReservable(companyID: $companyID, reservableID: $reservableID) {
            id
            startTime
            endTime
            companyID
            isOnlineMeeting
            onlineMeetingUrl
        }
    }
`

export const SUBSCRIPTION_UPDATE_ROOM_EVENT = gql`
    subscription OnUpdateRoomEvent($companyID: String!, $reservableID: String!) {
        onUpdateCalendarEventByReservable(companyID: $companyID, reservableID: $reservableID) {
            id
            startTime
            endTime
            companyID
            isOnlineMeeting
            onlineMeetingUrl
        }
    }
`

export const SUBSCRIPTION_DELETE_ROOM_EVENT = gql`
    subscription OnDeleteRoomEvent($companyID: String!, $reservableID: String!) {
        onDeleteCalendarEventByReservable(companyID: $companyID, reservableID: $reservableID) {
            id
            startTime
            endTime
            companyID
            isOnlineMeeting
            onlineMeetingUrl
        }
    }
`
